export enum DatePeriod {
    THREE_MONTHS = 'THREE_MONTHS',
    SIX_MONTHS = 'SIX_MONTHS',
    TWELVE_MONTHS = 'TWELVE_MONTHS'
}
